export default {
  screens: [
    {
      type: 'intro',
      title: 'Maison Chaumet',
      content:
        'In 1812, Chaumet was the first Maison to be established in the heart of the Place Vendôme at the current address of the Ritz. Parisian jewellery was born.',
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        'In 1907 Chaumet moved to its current address at 12 Place Vendôme. The private mansion houses the flagship boutique, private salons, creative studio and the High Jewellery atelier.',
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        'Such a prestigious address is a testament to the success of the Maison. <br><br> Innovative designer Marie-Etienne Nitot, founder of the Maison, passed on his virtuoso skills to his successors.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/home.js